import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const data = [
  { time: "06:00", oee: 82, fpy: 96 },
  { time: "08:00", oee: 85, fpy: 97 },
  { time: "10:00", oee: 88, fpy: 98 },
  { time: "12:00", oee: 84, fpy: 95 },
  { time: "14:00", oee: 87, fpy: 97 },
  { time: "16:00", oee: 91, fpy: 98 },
  { time: "18:00", oee: 89, fpy: 97 },
  { time: "20:00", oee: 86, fpy: 96 },
];

export function ProductionChart() {
  return (
    <div className="bg-card rounded-xl shadow-card border border-border p-5">
      <div className="mb-4">
        <h3 className="font-semibold text-foreground">Production Performance</h3>
        <p className="text-sm text-muted-foreground mt-0.5">OEE & FPY trends over current shift</p>
      </div>

      <div className="flex items-center gap-6 mb-4">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-primary" />
          <span className="text-sm text-muted-foreground">OEE %</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-success" />
          <span className="text-sm text-muted-foreground">FPY %</span>
        </div>
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id="oeeGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="var(--primary)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="var(--primary)" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="fpyGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="var(--success)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="var(--success)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" opacity={0.5} />
            <XAxis
              dataKey="time"
              tick={{ fontSize: 12, fill: "var(--muted-foreground)" }}
              axisLine={{ stroke: "var(--border)" }}
              tickLine={false}
            />
            <YAxis
              domain={[70, 100]}
              tick={{ fontSize: 12, fill: "var(--muted-foreground)" }}
              axisLine={{ stroke: "var(--border)" }}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "var(--card)",
                border: "1px solid var(--border)",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
              labelStyle={{ color: "var(--foreground)", fontWeight: 600 }}
            />
            <Area
              type="monotone"
              dataKey="oee"
              stroke="var(--primary)"
              strokeWidth={2}
              fill="url(#oeeGradient)"
            />
            <Area
              type="monotone"
              dataKey="fpy"
              stroke="var(--success)"
              strokeWidth={2}
              fill="url(#fpyGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
